import React from 'react'
import Image from 'next/legacy/image'

interface Props {
	color?: string
	colorSecondary?: string
	outline?: string
	width?: number
}

export const HomeIcon = (props: any): JSX.Element => (
	<Image src="/images/home-icon.png" width="40" height="38" alt="Home Icon" {...props} />
)

export const ChevronIcon = ({ color }: Props): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414">
		<path
			fill="none"
			stroke={color}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2px"
			d="M6 9l4 4 4-4"
			transform="translate(-4.586 -7.586)"
		/>
	</svg>
)

export const MenuIcon = ({ color }: Props): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<path
			id="prefix__icons8-grid-view"
			fill={color}
			d="M2.667 1A1.67 1.67 0 0 0 1 2.667v1.666A1.67 1.67 0 0 0 2.667 6h1.666A1.67 1.67 0 0 0 6 4.333V2.667A1.67 1.67 0 0 0 4.333 1zm7.5 0A1.67 1.67 0 0 0 8.5 2.667v1.666A1.67 1.67 0 0 0 10.167 6h1.667A1.67 1.67 0 0 0 13.5 4.333V2.667A1.67 1.67 0 0 0 11.833 1zm7.5 0A1.67 1.67 0 0 0 16 2.667v1.666A1.67 1.67 0 0 0 17.667 6h1.667A1.67 1.67 0 0 0 21 4.333V2.667A1.67 1.67 0 0 0 19.333 1zm-15 7.5A1.67 1.67 0 0 0 1 10.167v1.667A1.67 1.67 0 0 0 2.667 13.5h1.666A1.67 1.67 0 0 0 6 11.833v-1.666A1.67 1.67 0 0 0 4.333 8.5zm7.5 0A1.67 1.67 0 0 0 8.5 10.167v1.667a1.67 1.67 0 0 0 1.667 1.666h1.667a1.67 1.67 0 0 0 1.666-1.667v-1.666A1.67 1.67 0 0 0 11.833 8.5zm7.5 0A1.67 1.67 0 0 0 16 10.167v1.667a1.67 1.67 0 0 0 1.667 1.666h1.667A1.67 1.67 0 0 0 21 11.833v-1.666A1.67 1.67 0 0 0 19.333 8.5zm-15 7.5A1.67 1.67 0 0 0 1 17.667v1.667A1.67 1.67 0 0 0 2.667 21h1.666A1.67 1.67 0 0 0 6 19.333v-1.666A1.67 1.67 0 0 0 4.333 16zm7.5 0A1.67 1.67 0 0 0 8.5 17.667v1.667A1.67 1.67 0 0 0 10.167 21h1.667a1.67 1.67 0 0 0 1.666-1.667v-1.666A1.67 1.67 0 0 0 11.833 16zm7.5 0A1.67 1.67 0 0 0 16 17.667v1.667A1.67 1.67 0 0 0 17.667 21h1.667A1.67 1.67 0 0 0 21 19.333v-1.666A1.67 1.67 0 0 0 19.333 16z"
			transform="translate(-1 -1)"
		/>
	</svg>
)

export const ExternalIcon = ({ color }: Props): JSX.Element => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		id="prefix__icons_ic_external-normal"
		width="12"
		height="12"
		data-name="icons / ic_external-normal"
		viewBox="0 0 12 12"
	>
		<g id="prefix__Group_784" data-name="Group 784" transform="translate(2.898)">
			<g id="prefix__Group_783" data-name="Group 783">
				<path
					id="prefix__Path_153"
					d="M194.634 0h-5.2a.65.65 0 0 0 0 1.3h3.632l-6.692 6.692a.65.65 0 1 0 .919.919l6.692-6.692v3.632a.65.65 0 1 0 1.3 0V.65a.65.65 0 0 0-.651-.65z"
					fill={color}
					data-name="Path 153"
					transform="translate(-186.182)"
					stroke={color}
				/>
			</g>
		</g>
		<g id="prefix__Group_786" data-name="Group 786" transform="translate(0 2.17)">
			<g id="prefix__Group_785" data-name="Group 785">
				<path
					id="prefix__Path_154"
					d="M8.847 96.214a.52.52 0 0 0-.52.52v4.684H1.041v-7.286h4.684a.52.52 0 0 0 0-1.041H.52a.52.52 0 0 0-.52.52v8.327a.52.52 0 0 0 .52.52h8.327a.52.52 0 0 0 .52-.52v-5.2a.52.52 0 0 0-.52-.524z"
					data-name="Path 154"
					fill={color}
					transform="translate(0 -92.629)"
					stroke={color}
				/>
			</g>
		</g>
	</svg>
)

export const ExternalIconDark = (): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5" viewBox="0 0 13.5 13.5">
		<path
			fill="none"
			stroke="#323232"
			strokeMiterlimit="10"
			strokeWidth="1.5px"
			d="M16 10v5.25a.75.75 0 0 1-.75.75H4.75a.75.75 0 0 1-.75-.75V4.75A.75.75 0 0 1 4.75 4H10m6 4.5V4h-4.5M16 4l-8.25 8.25"
			transform="translate(-3.25 -3.25)"
		/>
	</svg>
)

export const LearnIcon = (): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32.5" height="32.5" viewBox="0 0 32.5 32.5">
		<g strokeWidth="0.5px">
			<path
				fill="#14e075"
				stroke="#14e075"
				d="M15.82 3.1A12.717 12.717 0 1 1 3.1 15.82 12.732 12.732 0 0 1 15.82 3.1z"
				transform="translate(.25 .25) translate(-2.82 3.18)"
			/>
			<path
				fill="#592b86"
				stroke="#592b86"
				d="M18 2a16 16 0 1 0 16 16A16.02 16.02 0 0 0 18 2zm0 1.1A14.9 14.9 0 1 1 3.1 18 14.914 14.914 0 0 1 18 3.1zm0 2.21a12.686 12.686 0 1 0 7.836 2.707.553.553 0 0 0-.683.869A11.586 11.586 0 1 1 18 6.414a11.646 11.646 0 0 1 1.692.123.552.552 0 0 0 .159-1.093A12.91 12.91 0 0 0 18 5.31zm4.157.741a.552.552 0 0 0-.166 1.069 10.724 10.724 0 0 1 1.276.558.563.563 0 0 0 .252.06.552.552 0 0 0 .253-1.038 12.1 12.1 0 0 0-1.4-.612.536.536 0 0 0-.215-.036zm1.643 4.908a1.161 1.161 0 0 0-.328.1l-7.554 3.537a2.75 2.75 0 0 0-1.33 1.33l-3.534 7.554a1.1 1.1 0 0 0 .994 1.573 1.121 1.121 0 0 0 .472-.106l7.554-3.537a2.685 2.685 0 0 0 .659-.444.621.621 0 0 0 .136-.091.5.5 0 0 0 .091-.134 2.823 2.823 0 0 0 .444-.662l3.534-7.554a1.1 1.1 0 0 0-1.138-1.566zm-12.164.358a.561.561 0 0 0-.388.166.554.554 0 0 0 .015.782l.793.767a.553.553 0 0 0 .767-.8l-.793-.767a.547.547 0 0 0-.39-.148zm12.3.739l-3.537 7.556a.016.016 0 0 1 0 .009l-.914-.912a1.634 1.634 0 0 0 .17-.709A1.658 1.658 0 0 0 18 16.345a1.633 1.633 0 0 0-.709.166l-.912-.914a.016.016 0 0 0 .009 0zM9.806 14.14a.553.553 0 0 0-.2 1.065l1.024.414a.534.534 0 0 0 .207.039.551.551 0 0 0 .207-1.062l-1.024-.414a.588.588 0 0 0-.214-.042zm5.794 2.239l.914.912a1.633 1.633 0 0 0-.166.709A1.658 1.658 0 0 0 18 19.655a1.634 1.634 0 0 0 .709-.166l.912.914a.016.016 0 0 1-.009 0l-7.556 3.537 3.537-7.556a.016.016 0 0 1 .007-.005zm2.4.907a.713.713 0 1 1-.713.713.713.713 0 0 1 .713-.712zm7.685.1a.55.55 0 0 0-.552.552.151.151 0 0 0 .006.03.172.172 0 0 0-.006.032.55.55 0 0 0 .552.552h1.142a.55.55 0 0 0 .552-.552.54.54 0 0 0-.08-.269.551.551 0 0 0-.511-.345zm-16.513 0a.55.55 0 0 0-.552.552.151.151 0 0 0 .006.03.214.214 0 0 0-.005.032.55.55 0 0 0 .552.552h1.1a.55.55 0 0 0 .555-.552.214.214 0 0 0-.006-.032.151.151 0 0 0 .006-.03.55.55 0 0 0-.552-.552zm15.942 2.892a.553.553 0 0 0-.2 1.065l1.024.414a.577.577 0 0 0 .207.039.551.551 0 0 0 .207-1.062l-1.026-.414a.522.522 0 0 0-.212-.042zm-1.605 2.472a.558.558 0 0 0-.388.17.549.549 0 0 0 .013.778l.793.767a.552.552 0 0 0 .767-.793l-.8-.767a.545.545 0 0 0-.385-.155z"
				transform="translate(.25 .25) translate(-2 -2)"
			/>
		</g>
	</svg>
)

export * from 'components/content/products/primaryIcons'
